import React from 'react';
import cn from 'clsx';
import { Typography } from 'common/components';
import { DESCRIPTION_BLOCK_CONTENT_MAP } from './description-block-constants';
import {
  descriptionBlock,
  descriptionBlockName,
  DescriptionBlockPattern,
  descriptionBlockPatternStylesMap,
  descriptionBlockStylesMap,
  descriptionBlockTitle,
  descriptionBlockWrapper,
} from './description-block-styles';

type DescriptionBlockProps = {
  style: string;
}

export const DescriptionBlock = ({ style }: DescriptionBlockProps) => {
  const styleInfo = DESCRIPTION_BLOCK_CONTENT_MAP[style];

  return (
    <div className={cn(descriptionBlock, descriptionBlockStylesMap[style])}>
      <div className={descriptionBlockWrapper}>
        <Typography adaptive={false} className={descriptionBlockTitle} variant="overline">
          {styleInfo.title}
        </Typography>
        <Typography adaptive={false} className={descriptionBlockName} variant="h2">
          {styleInfo.name}
        </Typography>
        <Typography adaptive={false} variant="m" size="body_long">
          {styleInfo.text}
        </Typography>
      </div>
      <DescriptionBlockPattern className={descriptionBlockPatternStylesMap[style]} />
    </div>
  );
}